import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { MapPin, Clock, CalendarDays, ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { PAGES } from "@/i18n/extra_translations";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UpcomingEvents = () => {
  const { lang } = useLanguage();
  const pg = PAGES[lang] || PAGES.en;
  const [events, setEvents] = useState([]);

  useEffect(() => {
    axios.get(`${API}/events`).then((r) => setEvents(r.data.events || [])).catch(() => {});
  }, []);

  return (
    <main className="pt-28 pb-20 px-6" data-testid="upcoming-events-page">
      <div className="max-w-7xl mx-auto lg:px-4">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <h1 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1A2F24]" data-testid="upcoming-events-title">{pg.upcoming_title}</h1>
          <p className="mt-6 text-base leading-relaxed text-[#5C7368]">{pg.upcoming_intro}</p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="upcoming-events-grid">
          {events.map((e, i) => (
            <motion.div
              key={e.id || i}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group h-full rounded-2xl bg-[#F2F4F0] border border-[#E2E8E4] p-8 transition-all duration-500 hover:border-[#F4A261]/60 hover:-translate-y-1"
              data-testid={`upcoming-event-card-${i}`}
            >
              <span className="inline-block rounded-full bg-[#C4D7D1] px-4 py-1.5 text-[10px] tracking-[0.2em] uppercase text-[#1E352A]">{e.tag}</span>
              <h3 className="font-display text-3xl mt-5 text-[#1A2F24]">{e.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#5C7368]">{e.description}</p>
              <div className="mt-6 space-y-2 text-xs text-[#5C7368]">
                <p className="flex items-center gap-2"><CalendarDays size={14} className="text-[#F4A261]" /> {e.date}</p>
                <p className="flex items-center gap-2"><Clock size={14} className="text-[#F4A261]" /> {e.time}</p>
                <p className="flex items-center gap-2"><MapPin size={14} className="text-[#F4A261]" /> {e.location}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a href="/past-events" data-testid="upcoming-see-past-btn"
            className="inline-flex items-center gap-2 rounded-full bg-[#1E352A] text-[#FAF9F6] px-8 py-4 text-sm tracking-[0.12em] uppercase transition-colors duration-300 hover:bg-[#F4A261] hover:text-white">
            {pg.btn_see_past} <ArrowRight size={15} />
          </a>
        </div>
      </div>
    </main>
  );
};

export default UpcomingEvents;
